/* ============================================================
   Stundenplan-Generator  (tp-stundenplan-generator.liquid)
   ------------------------------------------------------------
   Erzeugt einen druckfertigen A4-Stundenplan als PDF.
   Verarbeitung erfolgt vollständig lokal im Browser – es werden
   keine Daten hochgeladen, gespeichert oder übertragen.
   Abhängigkeit: jspdf.umd.min.js (window.jspdf)
   ============================================================ */
(function () {
  'use strict';

  var DAYS = {
    5: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag'],
    6: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    7: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag']
  };

  // Farb-Konvention identisch zum Theme (Navy / Orange / Cream)
  var COLORS = {
    navy: [15, 39, 68],
    orange: [232, 118, 30],
    cream: [249, 247, 243],
    border: [228, 224, 216],
    text: [85, 85, 85],
    white: [255, 255, 255]
  };

  function readConfig() {
    var cfg = window.tpStundenplanConfig || {};
    return {
      showBranding: cfg.showBranding !== false,
      brandingText: cfg.brandingText || 'Trioprint.de'
    };
  }

  function getNum(root, sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    var v = parseInt(el.value, 10);
    return isNaN(v) ? fallback : v;
  }

  function getVal(root, sel, fallback) {
    var el = root.querySelector(sel);
    return el ? el.value : fallback;
  }

  function isChecked(root, sel) {
    var el = root.querySelector(sel);
    return el ? !!el.checked : false;
  }

  function buildPdf(root) {
    if (!window.jspdf || !window.jspdf.jsPDF) {
      showMessage(root, 'PDF-Bibliothek konnte nicht geladen werden. Bitte Seite neu laden.', 'error');
      return;
    }

    var cfg = readConfig();
    var dayCount = getNum(root, '[data-sp-days]', 5);
    var lessons = getNum(root, '[data-sp-lessons]', 8);
    var orientation = getVal(root, '[data-sp-orientation]', 'landscape');
    var colored = isChecked(root, '[data-sp-color]');
    var withTime = isChecked(root, '[data-sp-time]');
    var title = (getVal(root, '[data-sp-title]', '') || 'Stundenplan').trim();

    var days = DAYS[dayCount] || DAYS[5];

    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' });

    var pageW = doc.internal.pageSize.getWidth();
    var pageH = doc.internal.pageSize.getHeight();
    var margin = 14;
    var contentW = pageW - margin * 2;

    // ---- Titel ----
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.setTextColor.apply(doc, COLORS.navy);
    doc.text(title, margin, margin + 6);

    var gridTop = margin + 14;
    var gridBottom = pageH - (cfg.showBranding ? margin + 8 : margin);
    var gridH = gridBottom - gridTop;

    // Spalten: optionale Zeitspalte + ein Header-Row + Tage
    var firstColW = withTime ? 26 : 16;
    var dayColW = (contentW - firstColW) / days.length;

    var headerRowH = 11;
    var bodyH = gridH - headerRowH;
    var rowH = bodyH / lessons;

    // ---- Kopfzeile (Wochentage) ----
    doc.setFillColor.apply(doc, COLORS.navy);
    doc.rect(margin, gridTop, contentW, headerRowH, 'F');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor.apply(doc, COLORS.white);

    var firstLabel = withTime ? 'Zeit' : 'Std.';
    doc.text(firstLabel, margin + firstColW / 2, gridTop + headerRowH / 2 + 1.5, { align: 'center' });

    for (var d = 0; d < days.length; d++) {
      var cx = margin + firstColW + dayColW * d + dayColW / 2;
      doc.text(days[d], cx, gridTop + headerRowH / 2 + 1.5, { align: 'center' });
    }

    // ---- Body-Zeilen ----
    for (var r = 0; r < lessons; r++) {
      var ry = gridTop + headerRowH + rowH * r;

      // Zebra-Streifen (cream) für gerade Zeilen
      if (r % 2 === 1) {
        doc.setFillColor.apply(doc, COLORS.cream);
        doc.rect(margin, ry, contentW, rowH, 'F');
      }

      // Stundennummer / Zeitspalte
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.setTextColor.apply(doc, colored ? COLORS.orange : COLORS.navy);
      if (withTime) {
        // leere Zeitfelder zum Eintragen, nur Stundennr. klein oben
        doc.text(String(r + 1) + '.', margin + 3, ry + rowH / 2 + 1);
      } else {
        doc.text(String(r + 1) + '.', margin + firstColW / 2, ry + rowH / 2 + 1.5, { align: 'center' });
      }
    }

    // ---- Rasterlinien ----
    doc.setDrawColor.apply(doc, COLORS.border);
    doc.setLineWidth(0.3);

    // Horizontale Linien
    for (var hr = 0; hr <= lessons; hr++) {
      var hy = gridTop + headerRowH + rowH * hr;
      doc.line(margin, hy, margin + contentW, hy);
    }
    // Linie unter Kopfzeile bereits durch Rect; Top-Linie der Body
    doc.line(margin, gridTop, margin + contentW, gridTop);

    // Vertikale Linien
    doc.line(margin, gridTop, margin, gridBottom);
    doc.line(margin + firstColW, gridTop, margin + firstColW, gridBottom);
    for (var vc = 1; vc <= days.length; vc++) {
      var vx = margin + firstColW + dayColW * vc;
      doc.line(vx, gridTop, vx, gridBottom);
    }
    // Rahmen unten
    doc.line(margin, gridBottom, margin + contentW, gridBottom);

    // Akzent-Linie unter Kopfzeile (orange)
    if (colored) {
      doc.setDrawColor.apply(doc, COLORS.orange);
      doc.setLineWidth(0.8);
      var accentY = gridTop + headerRowH;
      doc.line(margin, accentY, margin + contentW, accentY);
    }

    // ---- Branding-Fußzeile ----
    if (cfg.showBranding) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor.apply(doc, COLORS.text);
      doc.text(cfg.brandingText, pageW - margin, pageH - margin + 2, { align: 'right' });
    }

    var fileName = 'stundenplan-' + dayCount + '-tage-' + lessons + '-stunden.pdf';
    doc.save(fileName);
    showMessage(root, 'Dein Stundenplan wurde als PDF erstellt und heruntergeladen.', 'success');
  }

  function showMessage(root, text, type) {
    var box = root.querySelector('[data-sp-message]');
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
    box.setAttribute('data-state', type || 'info');
  }

  function init(root) {
    var btn = root.querySelector('[data-sp-generate]');
    if (btn) {
      btn.addEventListener('click', function () {
        buildPdf(root);
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-stundenplan-generator]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();